<template>
 
   <v-layout align-start>
    <v-flex>
        <v-toolbar text color="white">
            <v-toolbar-title>Objetivos</v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <v-spacer></v-spacer>

                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-3" v-on="on">Nuevo Objetivo</v-btn>
                    </template>

                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
                                        <v-col cols="12" sm="8" md="6">
                                            <v-select v-model="id_perspectiva"
                                                :items="nombre_perspectiva"  label="Perspectiva">
                                            </v-select>
                                        </v-col>                                        
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="nombre_objetivo" label="Nombre Objetivo"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                            <v-text-field v-model="descripcion_objetivo" label="Descripcion Objetivo"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-flex xs12 sm12 md12 v-show="valida">
                                        <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                                        </div>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click.native="close">Cancelar</v-btn>
                            <v-btn color="red darken-1" text @click.native="guardar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>cd
                </v-dialog>
 
                 <v-dialog v-model="adModal" max-width="290">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item? </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item? </v-card-title>
                    <v-card-text>
                        Estas a punto del
                        <span v-if="adAccion==1">Activar </span>
                        <span v-if="adAccion==2">Desactivar </span>
                        el item {{ adIdObjetivo}}    
                    </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                    Cancelar
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activar">
                                    Activar
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="desactivar">
                                    Desactivar
                                </v-btn>
                            </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>

   <v-data-table
        :headers="headers"
        :items="objetivos"
        :search="search"
        class="elevation-1"
    >     
                 <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                    >
                        mdi-grease-pencil
                    </v-icon>
                    <template v-if="item.estado_objetivo">
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(2,item)"
                        >
                            mdi-block-helper
                        </v-icon>
                    </template>
                    <template v-else>
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(1,item)"
                        >
                            mdi-check-all
                        </v-icon>
                    </template>
                </template>

                <template slot="items" slot-scope="props">
                    <td>{{ props.item.id_perspectiva }}</td>
                    <td>{{ props.item.nombre_perspectiva }}</td>
                    <td>{{ props.item.codigo_objetivo }}</td>
                    <td>{{ props.item.nombre_objetivo }}</td>
                    <td>{{ props.item.descripcion_objetivo }}</td>
                    <td>
                        <div v-if="props.item.estado_objetivo"   > 
                            <span class="blue--text">Activo</span>
                        </div>
                        <div v-else>
                            <span class="red--text">Inactivo</span>
                        </div>
                    </td>
                </template>

                <template slot="no-data">
                <v-btn color="primary" @click="listar">Resetear</v-btn>
                </template>
    </v-data-table>

        </v-flex>
    </v-layout>

</template>

<script>
import axios from 'axios'

export default {
    data(){
        return{
                objetivos:[],                
                dialog: false,
                headers: [
                    { text: 'Opciones', value: 'action', sortable: false},
                    { text: 'Nombre Perspectiva', value: 'nombre_perspectiva' },
//                    { text: 'codigo Perspectiva', value: 'codigo_perspectiva' },
                    { text: 'codigo Objetivo', value: 'codigo_objetivo' },
                    { text: 'Objetivo', value: 'nombre_objetivo' },
                    { text: 'Descripcion Objetivo', value: 'descripcion_objetivo' , sortable: false},                    
                    { text: 'Estado', value: 'estado_objetivo' , sortable: false}
                ],
                search: '',
                editedIndex: -1,
                id_perspectiva: '',
//                codigo_perspectiva:'',
                nombre_perspectiva:[                    
                ] , 
                codigo_objetivo:'',
                nombre_objetivo:'',
                descripcion_objetivo: '',
                estado_objetivo:'',               
                valida: 0,
                validaMensaje:[],
                adModal: 0,
                adAccion: 0,
                adIdObjetivo:'',
                adNombre:''
        }
    },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nuevo Objetivo' : 'Actualizar Objetivo'
            }
        },


    watch: {
        dialog (val) {
        val || this.close()
        },
    },

    created () {
        this.listar();
        this.select();
    },
    methods:
    {
		listar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};            
			axios.get('api/Objetivos/Listar',configuracion).then(function(response){
				//console.log(response);
				me.objetivos=response.data;
			}).catch(function(error){
				console.log(error);   
			});
		},
        select(){
            let me=this;
            var perspectivaindicadorArray= [];
			axios.get('api/Perspectivas/Select').then(function(response){
                //console.log(response);
                perspectivaindicadorArray=response.data;
                perspectivaindicadorArray.map(function(x){
                    me.nombre_perspectiva.push({text: x.nombre_perspectiva, value:x.id_perspectiva});
                });
			}).catch(function(error){
				console.log(error);   
			});
		},

		editItem (item) {
 			this.adIdObjetivo=item.id_objetivo;
            this.id_perspectiva=item.id_perspectiva;
 //           this.codigo_perspectiva = item.codigo_perspectiva;
            this.codigo_objetivo=item.codigo_objetivo;
            this.nombre_objetivo= item.nombre_objetivo;
			this.descripcion_objetivo=item.descripcion_objetivo;
			this.estado_objetivo=item.estado_objetivo;
            this.editedIndex=1;            
			this.dialog = true
		},

		close () {
            this.dialog = false;
            this.limpiar();
		},

		limpiar(){
			this.id_perspectiva="";
//			this.codigo_perspectiva="";
            this.codigo_objetivo= "";
            this.nombre_objetivo= "";
			this.descripcion_objetivo= "";
			this.editedIndex=-1;
		},


        guardar () {
            
			if(this.validar()){
				return;
			}
			if (this.editedIndex > -1) {
				// codigo para guardar
				let me=this;
				axios.put('api/Objetivos/Actualizar',{
                    'id_objetivo':me.adIdObjetivo,
                    'id_perspectiva': me.id_perspectiva,
//                    'codigo_perspectiva': me.codigo_perspectiva,
					'codigo_objetivo': me.codigo_objetivo,
					'nombre_objetivo': me.nombre_objetivo,
					'descripcion_objetivo':me.descripcion_objetivo,
                    'estado_objetivo':me.estado_objetivo
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});

			} else {
		   //     this.desserts.push(this.editedItem)
				let me=this;
				axios.post('api/Objetivos/Crear',{
					'codigo_objetivo': me.codigo_objetivo,
                    'id_perspectiva': me.id_perspectiva,
//                    'codigo_perspectiva': me.codigo_perspectiva,
					'nombre_objetivo': me.nombre_objetivo,
					'descripcion_objetivo':me.descripcion_objetivo,
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
                });
                
			}
        },

		validar(){
			this.valida=0;
            this.validaMensaje=[];
            if (!this.id_perspectiva){
                    this.validaMensaje.push("Seleccione una Perspectiva.");
                }
            if(!this.nombre_perspectiva){
				this.validaMensaje.push("Seleccione un nombre_perspectiva");
            }            
			if(this.nombre_objetivo < 3 || this.nombre_objetivo > 100){
				this.validaMensaje.push("El Nombre Objetivo debe tener mas de 3 caracteres y menos de 100 caracteres.");
            }
			if(!this.descripcion_objetivo){
				this.validaMensaje.push("Debe digitar una descripción para el objetivo. ");
            }
/*            if (!this.peso_objetivo || this.peso_objetivo < 0 ){
                    this.validaMensaje.push("El peso debe ser numerico.");
                }            
			if((this.peso_objetivo*1).toFixed(4) != (this.puntos_estrategia*1 + this.puntos_operacion*1).toFixed(4)) {
                this.validaMensaje.push("La suma de Puntos Estrategicos  y Puntos Operacion debe ser igual al valor de Peso Objetivo. " );
                this.validaMensaje.push((this.peso_objetivo*1).toFixed(4));
                this.validaMensaje.push((this.puntos_estrategia*1).toFixed(4));
                this.validaMensaje.push((this.puntos_operacion*1).toFixed(4));
                this.validaMensaje.push((this.puntos_estrategia*1 + this.puntos_operacion*1).toFixed(4));
                this.validaMensaje.push(Math.abs((this.peso_objetivo*1).toFixed(4) - (this.puntos_estrategia*1).toFixed(4) - (this.puntos_operacion*1).toFixed(4)));

//				this.validaMensaje.push("La suma de Puntos Estrategicos (" & this.puntos_estrategia & ") y Puntos Operacion (" & this.puntos_operacion & ") debe ser igual al valor de Peso Objetivo (" & this.peso_objetivo );
            }
*/  
		    if(this.validaMensaje.length){
				this.valida=1;
			}
		    return this.valida;
        },

        activarDesactivarMostrar(accion,item){
        this.adModal=1;
        this.adIdObjetivo =item.id_objetivo;
        if (accion==1){
            this.adAccion=1;
        }
        else if (accion==2){
        this.adAccion=2;
        }
        else{
        this.adModal=0;
        }
        },
        activarDesactivarCerrar(){
        this.adModal=0;
        },
        activar(){
            let me=this;
            axios.put('api/Objetivos/Activar/'+this.adIdObjetivo,{}).then(function(response){
            me.adModal=0;
            me.adAccion=0;
            me.adNombre="";
            me.adIdObjetivo="";
            me.listar();                       
            }).catch(function(error){
                console.log(error);
            });
        },
        desactivar(){
            let me=this;
            axios.put('api/Objetivos/Desactivar/'+this.adIdObjetivo,{}).then(function(response){
                me.adModal=0;
                me.adAccion=0;
                me.adIdObjetivo="";
                me.adNombre="";
                me.listar();                       
            }).catch(function(error){
            console.log(error);
        });
            }
        }        
    }
</script>